import ArticleList from './article-list.vue';
import Tags from './tags.vue';
import Grid from './grid.vue';
import LoadMore from './load-more.vue';

const install = (Vue) => {
  Vue.component(ArticleList.name, ArticleList);
  Vue.component(Tags.name, Tags);
  Vue.component(Grid.name, Grid);
  Vue.component(LoadMore.name, LoadMore);
};

export default {
  install,
};

export { ArticleList, Tags, Grid, LoadMore };
